import { X } from "lucide-react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Toaster } from "sonner";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FFB300", // Amber-500
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          fontWeight: "normal",
          "& .MuiInputLabel-root": {
            color: "white",
            fontWeight: "bold",
            "&.Mui-focused": {
              color: "white",
            },
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "18px",
            "& fieldset": { borderColor: "white" },
            "&:hover fieldset": { borderColor: "white" },
            "&.Mui-focused fieldset": { borderColor: "white" },
          },
          "& .MuiInputBase-input": {
            color: "white",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#FF4B4B", // Style for the asterisk
            fontSize: "1rem", // Change the size of the asterisk
          },
          // icon must be white
          "& .MuiInputAdornment-root .MuiSvgIcon-root": {
            color: "white",
          },
        },
        // Add specific styling for multiline TextField
        multiline: {
          // Custom styles for multiline text field
          "& .MuiInputBase-root": {
            padding: "10px", // Adjust padding for multiline text field
            lineHeight: "1.5", // Adjust line height for better readability
          },
          "& .MuiOutlinedInput-root": {
            paddingBottom: "10px", // Add padding to bottom of multiline input
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            color: "white",
            fontWeight: "bold",
            borderRadius: "18px", // Match border radius with TextField
            "& fieldset": {
              borderColor: "white", // Default border color
              paddingLeft: "16px", // Add padding to prevent label overlap
            },
            "&:hover fieldset": {
              borderColor: "white", // White border on hover
            },
            "&.Mui-focused fieldset": {
              borderColor: "white", // White border when focused
            },
          },
          "& .MuiSelect-icon": {
            color: "white", // Keep select icon white
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "18px",
          "& .MuiInputBase-input": {
            color: "white",
          },
          "& fieldset": {
            borderColor: "white !important",
            paddingLeft: "10px", // Add padding for the label
            // make the width for the label a bit bigger
            // "&.Mui-focused": {
            //   borderColor: "white",
            // },
          },
          "&:hover fieldset": {
            borderColor: "white !important",
          },
          "&.Mui-focused fieldset": {
            borderColor: "white !important",
          },
          // Default border width
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: "2px",

            // asterisk
            "& .MuiInputLabel-asterisk": {
              color: "#FF4B4B",
              fontSize: "1rem",
            },
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          // fontWeight: "bold",
          color: "white",
          fontWeight: "semiBold",

          "&.Mui-focused": {
            color: "white",
          },
          "& .MuiInputLabel-asterisk": {
            color: "#FF4B4B", // White asterisk for required fields
            // change size of asterisk
            fontSize: "1rem",
          },

          // push the border a bit to the right
        },
      },
    },

    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          color: "white",
        },
      },
    },

    // textfield icon must be white
  },
});

export default function GuestLayout({ children, title, cn }) {
  return (
    <ThemeProvider theme={theme}>
      <Toaster />
      <div className="relative bg-[#181714] flex min-h-screen flex-col justify-center items-center p-4 sm:p-6">
        {title && (
          <div className="w-full flex ml-4 sm:ml-8 mt-4 sm:mt-8">
            <div className="flex flex-col-reverse text-xl sm:text-2xl md:text-3xl lg:text-4xl tracking-tight text-white font-semibold">
              {title ?? "Log in to"}
              <div className="text-amber-500 flex items-center">
                <img
                  src="/img/cajuu.png"
                  alt="Metr Logo"
                  className="w-7 h-7 sm:w-9 sm:h-9 mr-2"
                />
                Cajuu<span className="text-[#2f2f2f]/40">.</span>
              </div>
            </div>
          </div>
        )}

        <div
          className={[
            cn,
            "w-full sm:max-w-md animate-fade lg:max-w-lg p-4 sm:p-6 overflow-hidden sm:rounded-md",
          ].join(" ")}
        >
          {children}
        </div>
      </div>
    </ThemeProvider>
  );
}
